import { render, staticRenderFns } from "./CommentsSection.vue?vue&type=template&id=078859d4&scoped=true&"
import script from "./CommentsSection.vue?vue&type=script&lang=js&"
export * from "./CommentsSection.vue?vue&type=script&lang=js&"
import style0 from "./CommentsSection.vue?vue&type=style&index=0&id=078859d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078859d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078859d4')) {
      api.createRecord('078859d4', component.options)
    } else {
      api.reload('078859d4', component.options)
    }
    module.hot.accept("./CommentsSection.vue?vue&type=template&id=078859d4&scoped=true&", function () {
      api.rerender('078859d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/Comments/CommentsSection.vue"
export default component.exports